module.exports = __webpack_public_path__ + "static/media/popo-happy.eee3ce00.png";